import { combineReducers } from 'redux';
import types from './types';
import CreditModel from 'src/model/credit.model';

export interface ICreditError {
  hasFailed: boolean;
  message: string;
}

const INITIAL_IS_PENDING = false;
const INITIAL_ERROR: ICreditError = {
  hasFailed: false,
  message: ''
};

const payments = (
  state: CreditModel[] = [],
  { type, payload }: { type: string; payload: any[] }
) => {
  switch (type) {
    case types.SET_CREDITS_PAYMENTS:
      return payload;

    default:
      return state;
  }
};

const statusFilter = (
  state: 'PENDING' | 'VOID' | 'DISPOSED' = null,
  { type, payload }: { type: string; payload: 'PENDING' | 'VOID' | 'DISPOSED' }
) => {
  switch (type) {
    case types.SET_CREDITS_STATUS_FILTER:
      return payload;

    default:
      return state;
  }
};

const pageNumber = (
  state: number = 0,
  { type, payload }: { type: string; payload: number }
) => {
  switch (type) {
    case types.SET_CREDITS_PAGE_NUMBER:
      return payload;

    default:
      return state;
  }
};

const pageSize = (
  state: number = 0,
  { type, payload }: { type: string; payload: number }
) => {
  switch (type) {
    case types.SET_CREDITS_PAGE_SIZE:
      return payload;

    default:
      return state;
  }
};

const totalElements = (
  state: number = 0,
  { type, payload }: { type: string; payload: number }
) => {
  switch (type) {
    case types.SET_CREDITS_TOTAL_ELEMENTS:
      return payload;

    default:
      return state;
  }
};

const totalPages = (
  state: number = 0,
  { type, payload }: { type: string; payload: number }
) => {
  switch (type) {
    case types.SET_CREDITS_TOTAL_PAGES:
      return payload;

    default:
      return state;
  }
};

const isPending = (
  state: boolean = INITIAL_IS_PENDING,
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.SET_CREDITS_IS_PENDING:
      return payload;

    default:
      return state;
  }
};

const error = (
  state: ICreditError = INITIAL_ERROR,
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.SET_CREDITS_ERROR:
      return payload;
    default:
      return state;
  }
};

const creditsReducer = combineReducers({
  payments,
  statusFilter,
  pageNumber,
  pageSize,
  totalElements,
  totalPages,
  isPending,
  error
});

export default creditsReducer;
